export default {
  modelName: "tag",
  label: "標籤",
  fields: {
    locales: {
      type: "locales",
      fields: {
        name: {
          type: "text",
          label: "標籤文字",
          autofocus: true,
          rules: 'required',
          maxlength: 30
        }
      }
    },
    name: {
      type: 'text',
      label: '標籤文字',
      readonly: true
    },
    sequence: {
      type: "text",
      label: "排序",
      maxlength: 10
    },
    updated_at: {
      type: "datetime",
      label: "最後更新時間",
      readonly: true
    },
    updated_admin: {
      type: "belongsTo",
      label: "最後更新人",
      readonly: true,
      textKey: "name",
      modeldataName: "admin"
    },
  },
}